import { Injectable } from '@angular/core';
import { AppSettingsService } from '../appSettings/AppSettingsService';
import { UserInfo } from './UserInfo';

@Injectable({
    providedIn: 'root'
})
export class UserInformationService {
    public static $name: string = 'userInfoService';

    constructor(
        private appSettingsService: AppSettingsService
    ) {
    }

    public getUserInfo() {
        const metadata = this.appSettingsService.getMetadata();

        return {
            // Nola users will have both equivalent, no need to display twice
            userEmail: metadata.userName === metadata.userEmail ? '' : metadata.userEmail,
            userEmailHash: metadata.userEmailHash,
            userName: metadata.userName
        } as UserInfo;
    }

    public getUserName() {
        const userInfo = this.getUserInfo();

        return userInfo ? userInfo.userName : '';
    }
}
